import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DbmBoxListComponent } from './dbm-box-list.component';

@NgModule({
    imports: [CommonModule],
    declarations: [DbmBoxListComponent],
    entryComponents: [DbmBoxListComponent],
    exports: [DbmBoxListComponent]
})
export class DbmBoxListModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-box-list/dbm-box-list.module.ts